import queryApi from "./queryApi.js";
import adminApi from "./adminApi.js";
// import store from '@/store/index.js';

export default {
  //查询接口
  GET_PRO_CLS_INFO: queryApi.GET_PRO_CLS_INFO,
  GET_MALL_PRO_INFO: queryApi.GET_MALL_PRO_INFO,
  GET_MALL_PRO_SPEC_INFO: queryApi.GET_MALL_PRO_SPEC_INFO,
  GET_FEED_CLS_INFO: queryApi.GET_FEED_CLS_INFO,
  GET_FEED_INFO: queryApi.GET_FEED_INFO,
  GET_PRO_FEED_INFO: queryApi.GET_PRO_FEED_INFO,
  GET_FLAV_CLS_INFO: queryApi.GET_FLAV_CLS_INFO,
  GET_FLAV_INFO: queryApi.GET_FLAV_INFO,
  GET_PRO_FLAV_INFO: queryApi.GET_PRO_FLAV_INFO,
  GET_MALL_INFO: queryApi.GET_MALL_INFO,
  GET_MALL_CLS_INFO: queryApi.GET_MALL_CLS_INFO,
  GET_DTABLE_CLS_INFO: queryApi.GET_DTABLE_CLS_INFO,
  GET_DTABLE_INFO: queryApi.GET_DTABLE_INFO,
  GET_USER_INFO: queryApi.GET_USER_INFO,
  GET_USER_CLS_INFO: queryApi.GET_USER_CLS_INFO,
  GET_REMARK_INFO: queryApi.GET_REMARK_INFO,
  GET_MALL_ACCT_INFO: queryApi.GET_MALL_ACCT_INFO,
  GET_MALL_COMBO_INFO: queryApi.GET_MALL_COMBO_INFO,
  GET_AUTO_CODE_LIB: queryApi.GET_AUTO_CODE_LIB,
  GET_VIP_CLS_INFO: queryApi.GET_VIP_CLS_INFO,
  GET_VIP_INFO: queryApi.GET_VIP_INFO,
  GET_POS_MASTER: queryApi.GET_POS_MASTER,
  GET_POS_PRO_TOTAL: queryApi.GET_POS_PRO_TOTAL,
  GET_POS_PRO_DETAIL: queryApi.GET_POS_PRO_DETAIL,
  GET_MCH_LNK_ACCT_INFO: queryApi.GET_MCH_LNK_ACCT_INFO,
  GET_SAAS_MCH_USER_BAND_INFO: queryApi.GET_SAAS_MCH_USER_BAND_INFO,
  GET_AUTO_CODE_LIB: queryApi.GET_AUTO_CODE_LIB,
  GET_VIP_RCHG_RULE: queryApi.GET_VIP_RCHG_RULE,
  GET_SD_PRO_CLS_INFO: queryApi.GET_SD_PRO_CLS_INFO,
  GET_SD_MALL_PRO_INFO: queryApi.GET_SD_MALL_PRO_INFO,
  GET_BASE_INFO: queryApi.GET_BASE_INFO,
  GET_VEN_CLS_INFO: queryApi.GET_VEN_CLS_INFO, //获取供应商分类信息
  GET_MALL_AMT_ACCT_INFO: queryApi.GET_MALL_AMT_ACCT_INFO, //获取金额账户信息
  GET_MALL_FEE_INFO: queryApi.GET_MALL_FEE_INFO, //获取费用账户信息
  GET_BRAND_INFO: queryApi.GET_BRAND_INFO, //获取品牌信息



  //操作接口
  PRO_CLS_INFO: adminApi.PRO_CLS_INFO,
  MALL_PRO_INFO: adminApi.MALL_PRO_INFO,
  MALL_PRO_SPEC_INFO: adminApi.MALL_PRO_SPEC_INFO,
  PRO_FEED_INFO: adminApi.PRO_FEED_INFO,
  FEED_CLS_INFO: adminApi.FEED_CLS_INFO,
  FEED_INFO: adminApi.FEED_INFO,
  FLAV_CLS_INFO: adminApi.FLAV_CLS_INFO,
  PRO_FLAV_INFO: adminApi.PRO_FLAV_INFO,
  FLAV_INFO: adminApi.FLAV_INFO,
  MALL_INFO: adminApi.MALL_INFO,
  MALL_CLS_INFO: adminApi.MALL_CLS_INFO,
  DTABLE_CLS_INFO: adminApi.DTABLE_CLS_INFO,
  DTABLE_INFO: adminApi.DTABLE_INFO,
  USER_CLS_INFO: adminApi.USER_CLS_INFO,
  USER_INFO: adminApi.USER_INFO,
  REMARK_INFO: adminApi.REMARK_INFO,
  MALL_ACCT_INFO: adminApi.MALL_ACCT_INFO,
  MALL_COMBO_INFO: adminApi.MALL_COMBO_INFO,
  VIP_CLS_INFO: adminApi.VIP_CLS_INFO,
  VIP_INFO: adminApi.VIP_INFO,
  CRT_SAAS_DB: adminApi.CRT_SAAS_DB,
  SD_PRO_CLS_INFO: adminApi.SD_PRO_CLS_INFO,
  VEN_CLS_INFO: adminApi.VEN_CLS_INFO, //供应商分类信息
  BRAND_INFO: adminApi.BRAND_INFO, //品牌信息


};



//////////////////
// WEBPACK FOOTER
// ./common/api/smCommon.js
// module id = null
// module chunks = 